import { apiGet } from '../../MainModule/common/apiTools';
import { getServiceBaseURL } from '../../MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from '../../MainModule/enums/APIServiceEnum';

export async function fetchIsOrgInSonkoRegistry(ogrn: string | undefined, inn: string | undefined): Promise<boolean> {
  const queryParams = new URLSearchParams();

  ogrn && queryParams.append('ogrn', ogrn);
  inn && queryParams.append('inn', inn);

  return apiGet<boolean>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/sonko-catalog/find-org?${
      queryParams.toString().length ? `${queryParams}` : ''
    }`,
  );
}
